import { GameUIMessageType, StopAutoplayClickedMessage } from 'game-ui-types'
import { useUltraPlayStore } from '@stores/ultraPlayStore'
import { collectUltraPlayWin } from './ultraPlayCollect'

export const isUltraPlayPauseBlocked = (): boolean => {
    const up = useUltraPlayStore.getState()

    return up.isBetInFlight || up.isInFeature
}

export const executeUltraPlayPause = () => {
    const up = useUltraPlayStore.getState()

    up.pause()
    up.setPauseInFlight(true)
    collectUltraPlayWin()
    window.postMessage({ type: GameUIMessageType.STOP_AUTOPLAY_CLICKED } as StopAutoplayClickedMessage, '*')
}

export const flushPendingUltraPlayPause = () => {
    const up = useUltraPlayStore.getState()

    if (!up.isPausePending) return

    if (up.status !== 'PLAYING') {
        up.setPausePending(false)

        return
    }

    if (up.isPauseInFlight || isUltraPlayPauseBlocked()) return

    executeUltraPlayPause()
}
